import React, {
    useState,
    useRef,
} from 'react'
import {
    ToolbarButton,
    ExportCsv,
    ExportPrint,
} from '@mui/x-data-grid-pro'
import FileDownloadIcon from '@mui/icons-material/FileDownloadOutlined'
import Menu from '@mui/material/Menu'
import MenuItem from '@mui/material/MenuItem'
import Tooltip from '@mui/material/Tooltip'
import {
    noop,
} from 'lodash'

type Props = {
    CustomTrigger?: (props: {
        onClick?: (event: React.MouseEvent) => void
        ref?: React.Ref<any>
        'data-testid'?: string
    }) => JSX.Element,
    onItemClick?: () => void,
    embeddedInMenu?: boolean
}

const defaultProps: Partial<Props> = {
    CustomTrigger: undefined,
    onItemClick: noop,
    embeddedInMenu: false,
}

const ExportToolbarMenu = ({
    CustomTrigger,
    onItemClick,
    embeddedInMenu,
}: Readonly<Props>) => {
    const [
        exportMenuOpen,
        setExportMenuOpen,
    ] = useState(false)
    const exportMenuTriggerRef = useRef<HTMLButtonElement>(null)

    const handleClose = () => {
        setExportMenuOpen(false)
        onItemClick()
    }

    const handleTriggerClick = (event: React.MouseEvent) => {
        if (embeddedInMenu) {
            const parentMenu = event.currentTarget.closest('[role="menu"]')

            if (parentMenu) {
                exportMenuTriggerRef.current = parentMenu.parentElement as HTMLButtonElement
            }
        }
        setExportMenuOpen(true)
    }

    return (
        <>
            {CustomTrigger
                ? (
                    <CustomTrigger
                        ref={!embeddedInMenu ? exportMenuTriggerRef : undefined}
                        onClick={handleTriggerClick}
                        data-testid="export-toolbar-button-custom-trigger"
                    />
                )
                : (
                    <Tooltip title="Export">
                        <ToolbarButton
                            ref={exportMenuTriggerRef}
                            onClick={handleTriggerClick}
                            data-testid="export-toolbar-button"
                        >
                            <FileDownloadIcon fontSize="small" />
                        </ToolbarButton>
                    </Tooltip>
                )}

            <Menu
                anchorEl={exportMenuTriggerRef.current}
                open={exportMenuOpen}
                onClose={handleClose}
                anchorOrigin={{
                    vertical: embeddedInMenu ? 'top' : 'bottom',
                    horizontal: 'right',
                }}
                transformOrigin={{
                    vertical: 'top',
                    horizontal: embeddedInMenu ? 'left' : 'right',
                }}
                data-testid="export-menu"
            >
                <ExportPrint
                    render={<MenuItem />}
                    onClick={handleClose}
                    data-testid="export-menu-print"
                >
                    Print
                </ExportPrint>
                <ExportCsv
                    render={<MenuItem />}
                    onClick={handleClose}
                >
                    Download as CSV
                </ExportCsv>
            </Menu>
        </>
    )
}

ExportToolbarMenu.defaultProps = defaultProps

export default ExportToolbarMenu
